import { useCallback, useEffect, useState } from "react";
import CadastroOutput from "../../models/CadastroOutput";
import UsuarioOutput from "../../../usuario/models/UsuarioOutput";
import { useStatusFetch } from "../../../shared/hooks/useStatusFetch";
import http from "../../../../http";
import { useRecarregaAoRenovarToken } from "../../../shared/hooks/useRecarregaAoRenovarToken";

export const useBuscaListaCadastrosInativos = () => {

  const [listaCadastrosInativos, setListaCadastrosInativos] = useState([])
  const { needFetching } = useStatusFetch(listaCadastrosInativos)

  const buscaListaCadastrosInativos = useCallback(() => {
    http.get(`/cadastros-inativos`)
      .then(res => {
        const resposta = res.data
        const listaCadastros = resposta.map(cadastro => {
          const { Usuario, ...demaisCamposCadastro } = cadastro
          const cadastrosAtivos = CadastroOutput.create(demaisCamposCadastro)
          const usuario = UsuarioOutput.create(Usuario)
          return {
            usuario,
            cadastro: cadastrosAtivos
          }
        })
        setListaCadastrosInativos(listaCadastros)
      })
      .catch(() => setListaCadastrosInativos([]))
  }, [])

  useEffect(() => {
    if (!needFetching) return
    buscaListaCadastrosInativos()
    
  }, [needFetching, buscaListaCadastrosInativos])

  useRecarregaAoRenovarToken(buscaListaCadastrosInativos)

    return {
      listaCadastrosInativos
    };
  };
